import { render, staticRenderFns } from "./ActionDelete.vue?vue&type=template&id=5e2caecc&"
import script from "./ActionDelete.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActionDelete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports